export default __webpack_public_path__ + "static/media/0015.fd108b54.WAV";